export const featureFlags: { name: string; value: boolean }[] = [
	// Graphs
	{ name: "FISCAL_OVERVIEW_BY_YEAR_DISPLAY_BUTTONS", value: false },
	{ name: "FEATURE_ENABLE_FISCAL_OVERVIEW_DATE_SELECTOR", value: false },
	{ name: "PROJECT_DISPLAY_DATE_SELECTOR", value: false },
	{ name: "ENABLE_NAV_ARROWS_ON_GRAPHS", value: false },

	// Energy supplier partnerships
	{ name: "PROJECT_DISPLAY_ENERGY_SUPPLIER_LINK", value: false },

	// Communication hub
	{ name: "PROJECT_DISPLAY_MESSAGE_COUNT", value: false },

	// Mobile UX
	{ name: "ENABLE_MENU_COLLAPSE_ON_DESKTOP", value: false },

	// Stats
	{ name: "ENABLE_STATS_MY_SAVINGS", value: false },
	{ name: "ENABLE_STATS_IMPACT", value: false },
	{ name: "ENABLE_DISPLAY_IRR", value: false },

	// Project timeline
	{ name: "FEATURE_ENABLE_PROJECT_TIMELINE", value: false },

	// Investor profile
	{
		name: "FEATURE_ENABLE_INVESTOR_FUND_ORIGINS",
		value: false,
	},

	// Analytics
	// Kill-switch for Plausible tracking (init + custom events). Volume is
	// held under the 100k/month plan via a per-session pageview cap and the
	// redirect-double-fire drop in `src/lib/analytics.ts`. Flip back to false
	// if we approach the plan cap again.
	{ name: "ENABLE_PLAUSIBLE_ANALYTICS", value: true },
]
